/* global OfficeRuntime */

const STORAGE_KEY = "osdk_tokens";

export interface StoredTokens {
  accessToken: string;
  refreshToken?: string;
  expiresAt: number; // epoch ms
}

export async function getTokens(): Promise<StoredTokens | undefined> {
  const raw = await OfficeRuntime.storage.getItem(STORAGE_KEY);
  if (!raw) return undefined;
  try {
    return JSON.parse(raw) as StoredTokens;
  } catch {
    return undefined;
  }
}

export async function setTokens(tokens: StoredTokens): Promise<void> {
  await OfficeRuntime.storage.setItem(STORAGE_KEY, JSON.stringify(tokens));
}

export async function clearTokens(): Promise<void> {
  await OfficeRuntime.storage.removeItem(STORAGE_KEY);
}

/** Returns true if the access token is missing or within 60s of expiry. */
export function isExpired(tokens: StoredTokens | undefined, skewMs = 60_000): boolean {
  if (!tokens?.accessToken) return true;
  return Date.now() >= tokens.expiresAt - skewMs;
}
